import { useQuery } from "@tanstack/react-query";
import { checkPurchasePolicy } from "src/api/booksOrder";
export const CHECK_ORDER_QUERY_KEY = "checkOrder";
const useCheckOrder = (param)=>{
    let { targetType , targetId , enabled  } = param;
    return useQuery({
        queryKey: [
            CHECK_ORDER_QUERY_KEY,
            targetType,
            targetId
        ],
        queryFn: ()=>checkPurchasePolicy({
                targetType,
                targetId
            }),
        enabled: Boolean(targetType) && Boolean(targetId) && enabled
    });
};
export default useCheckOrder;
